import { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import HOC from '../../HOC';
import { Video } from '../../../activities';
import { syncState } from '../../../helpers/iframeHelper';
import { saveInteraction } from '../../../helpers/gamification';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';
import ProgressIndicator from '../../../common/ProgresIndicator';

const Title = styled.h1`
  margin-bottom: 10px;
  font-size: 18px;
`;

const Container = styled.div`
  width: 82%;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background-color: white;
  margin-top: 10px;
  margin-right: auto;
  margin-left: auto;
  border-radius: 4px;
  padding-bottom: 20px;
`;

const RF = ({
  location,
  discoveryData,
  updateDiscoveryData,
  accountId,
  setHeaderState,
  viewedEducationData
}) => {
  const { state } = location;
  const { id: idFromParam } = useParams();
  const allRFLessonsData = Object.values(discoveryData?.recyclingFundamentals) || null;
  const viewedRFLessons = viewedEducationData?.rfLessons || [];
  const doneRf = (id) => {
    const newData = discoveryData.recyclingFundamentals[id];
    newData.done = true;
    updateDiscoveryData({
      ...discoveryData,
      recyclingFundamentals: {
        ...discoveryData.recyclingFundamentals,
        [id]: newData
      }
    });
    saveInteraction({
      type: 'RF',
      state: newData.id
    });
    syncState();
  };
  const sortedRfLessons = allRFLessonsData
    .sort((a, b) => viewedRFLessons.includes(a?.id)
      - viewedRFLessons.includes(b?.id));
  const windowRef = useRef(window);
  const [swipeIndex, setSwipeIndex] = useState(
    sortedRfLessons.findIndex((i) => i.id === idFromParam)
  );

  useEffect(() => {
    windowRef.current.scrollTo(0, 0);

    if (sortedRfLessons) {
      trackEvent(events.DZ_RF_LAND, {
        rf_id: sortedRfLessons[swipeIndex].id,
        activity_id: sortedRfLessons[swipeIndex].activity.coachable_id,
        lesson_oidx: sortedRfLessons[swipeIndex].oidx,
        lesson_last: sortedRfLessons[swipeIndex].isLastItem
      });
      setHeaderState({
        rf_id: sortedRfLessons.find((item) => item.oidx === swipeIndex).id,
        activity_id: sortedRfLessons[swipeIndex].activity.coachable_id,
        lesson_oidx: sortedRfLessons[swipeIndex].oidx,
        lesson_last: sortedRfLessons[swipeIndex].isLastItem,
      });
      doneRf(sortedRfLessons[swipeIndex].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [swipeIndex]);

  const startVideoRequest = async () => {
    // Start video request
    trackEvent(events.DZ_RF_VIDEO_START, {
      activity_id: sortedRfLessons[swipeIndex].activity.coachable_id,
      lesson_oidx: sortedRfLessons[swipeIndex].oidx,
      lesson_last: sortedRfLessons[swipeIndex].isLastItem,
      campaign_id: sortedRfLessons[swipeIndex].id
    });
  };

  const endVideoRequest = async () => {
    // End video request
    trackEvent(events.DZ_RF_VIDEO_END, {
      activity_id: sortedRfLessons[swipeIndex].activity.coachable_id,
      lesson_oidx: sortedRfLessons[swipeIndex].oidx,
      lesson_last: sortedRfLessons[swipeIndex].isLastItem,
      campaign_id: sortedRfLessons[swipeIndex].id
    });
  };

  return (
    <div>
      {sortedRfLessons ? (
        <>
          <SwipeableViews
            index={swipeIndex}
            onChangeIndex={(i) => {
              setSwipeIndex(i);
            }}
            enableMouseEvents
            animateHeight
          >
            {
              sortedRfLessons.map((item) => (
                <div style={{ paddingBottom: '25px' }}>
                  <Container>
                    <Title>{item.title}</Title>
                    <Video
                      data={item.activity}
                      setHeaderState={setHeaderState}
                      id={item.id}
                      swipeIndex={swipeIndex}
                      setSwipeIndex={setSwipeIndex}
                      onDone={() => { }}
                      accountId={accountId}
                      lessonData={sortedRfLessons}
                      startVideoRequest={startVideoRequest}
                      endVideoRequest={endVideoRequest}
                    />
                  </Container>
                </div>

              ))
            }
          </SwipeableViews>
          <ProgressIndicator
            data={sortedRfLessons}
            index={swipeIndex}
            setIndex={setSwipeIndex}
            accessibilityLabel="Recycling Fundamentals"
          />
        </>

      ) : null}
    </div>
  );
};

export default HOC(RF);
